import React from "react";
import {IFormField} from "../../../models/forms/form-field.interface";
import {NullableString} from "../../../types/nullable-types";
import {observer} from "mobx-react";
import {StringFieldEditorComponent} from "../string-field/string-field-editor.component";
import {FieldEditorCommonProps} from "../inputs-common.props";

interface PhoneFieldEditorComponentProps extends FieldEditorCommonProps {
    field: IFormField<NullableString>;
    className?: string;
}

export const PhoneFieldEditorComponent: React.FC<PhoneFieldEditorComponentProps> = observer((props) => {


    return (
        <StringFieldEditorComponent {...props} inputMode="tel" className={props.className}/>
    )
});

